import { ModalHelper } from '@/helpers/modal-helper-vfm';
import { captureMessageForSentry } from '@/helpers/sentry-helper';

import { AccountModal } from '@/lazy-load-components';

import { ToggleMySportsNotificationPayload } from '@/features/sports/types/enums';
import { AccountModes } from '@/enums/login';
import {
	ToggleMySportsNotificationDocument,
	ToggleMySportsNotificationMutation,
	ToggleMySportsNotificationMutationVariables,
} from '@/features/sports/graphql/mutations/ToggleMySportsNotification.mutation';

import { useMutation } from '@/helpers/composables/useApollo';

export async function toggleMySportsNotification(
	{ eventId, isNotificationActive }: ToggleMySportsNotificationPayload,
	isLoggedIn: boolean
) {
	if (!isLoggedIn) {
		ModalHelper.openModal(
			AccountModal,
			{
				closable: true,
				startScreen: AccountModes.SIGN_UP,
			},
			{ cssClass: 'login-modal' }
		);

		return;
	}

	toggleNotificationMutation(eventId, !isNotificationActive);
}

function toggleNotificationMutation(id: string, state: boolean) {
	const { mutate, onError } = useMutation<
		ToggleMySportsNotificationMutation,
		ToggleMySportsNotificationMutationVariables
	>(ToggleMySportsNotificationDocument, {
		variables: {
			input: {
				id,
				state,
			},
		},
	});

	mutate();

	onError(error =>
		captureMessageForSentry(
			'[GraphQL ToggleMySportsNotification]:',
			{ error, where: 'Helper: sports-notification-helper' },
			'error'
		)
	);
}
